import React from "react";
import WishlistContainer from "./WishlistContainer";
import Navbar from "../../components/Navbar/Navbar";

const Wishlist = () => {
  return (
    <>
      <Navbar />
      <WishlistContainer />
    </>
  );
};

export default Wishlist;
